import React, { useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import { ThreadsList } from '@ts-core/components/Forum';

import { useThreads } from '@ts-core/hooks/forum';
import ToMainMenuButton from '@ts-core/components/ToMainMenuButton';

const ThreadsPage = () => {
  const history = useHistory();
  const { courseId } = useParams();
  const { threads, loading } = useThreads({ courseId });

  const onCreateNewPost = useCallback(() => {
    history.push(`/${courseId}/forum/new-thread`);
  }, [history, courseId]);

  return (
    <>
      <ToMainMenuButton />
      <ThreadsList
        threads={threads}
        loading={loading}
        onCreatePost={onCreateNewPost}
      />
    </>
  );
};

export default ThreadsPage;
